import {doc} from './docs.js';

doc(
    "get",
    {
        field: "number",
    },
    "Gets field from meessage. I.E. get ",
    undefined,
    {
        tags: "Object Utilities",
    }
);

export const get = (object, field) =>  {
    return (msg) => {
        if (msg[0][field()] === null ||
            msg[0][field()] === undefined) {
            return undefined;
        }
        return [
            msg[0][field()]
        ];
    };
};

doc(
    "set",
    {
        field: "number",
        value: "number",
    },
    "Sets field from message. I.E. set ",
    undefined,
    {
        tags: "Object Utilities",
    }
);

export const set = (object, field, value) =>  {
    return (msg) => {
        msg[0][field()] = value();
        return [
            value()
        ];
    };
};

